import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCartShopping } from "@fortawesome/free-solid-svg-icons";

const Loading = () => {
  return (
    <div className="loading-spinner">
      <FontAwesomeIcon icon={faCartShopping} bounce size="3x" />
      <p>Loading...</p>
    </div>
  );
};

export default Loading;
